/** Prefix New Chat drafts by tab or project so parallel composers and voice sessions stay separate */
const TAB_DRAFT_ID_PREFIX = 'tab:';
const PROJECT_DRAFT_ID_PREFIX = 'project:';

export function getTabDraftId(tabId: string): string {
  return `${TAB_DRAFT_ID_PREFIX}${tabId}`;
}

export function getProjectDraftId(projectId: string): string {
  return `${PROJECT_DRAFT_ID_PREFIX}${projectId}`;
}

export function getTabIdFromDraftId(draftId: string): string | undefined {
  return draftId.startsWith(TAB_DRAFT_ID_PREFIX)
    ? draftId.slice(TAB_DRAFT_ID_PREFIX.length)
    : undefined;
}

export function getProjectIdFromDraftId(draftId: string): string | undefined {
  return draftId.startsWith(PROJECT_DRAFT_ID_PREFIX)
    ? draftId.slice(PROJECT_DRAFT_ID_PREFIX.length)
    : undefined;
}

/**
 * Resolve which project the chat created from a New Chat draft belongs to.
 *
 * The two inputs describe different things. `draftId` says which New Chat
 * composer the draft belongs to: the regular New Chat page uses
 * `tab:<tabId>`, a project page's New Chat uses `project:<projectId>` - so
 * the ID itself carries the page's default project, when there is one.
 * `draftProjectId` is the user's choice in that composer's project selector,
 * saved on the draft as `Draft.projectId`.
 *
 * The cases:
 * - `draftProjectId` is a string: the user selected that project. It wins on
 *   either page.
 * - `draftProjectId` is `null`: the user selected "no project", clearing a
 *   project page's default. The chat gets no project.
 * - `draftProjectId` is `undefined`: the selector was never touched, so the
 *   page default applies: a project page's draft yields its project, a
 *   regular New Chat draft yields none.
 *
 * A string result means the chat is created in that project; `null` or
 * `undefined` mean no project. After creation, the thread's own `projectId`
 * is the authority.
 */
// TODO: Seems like a mess, we should refactor
export function resolveNewChatProjectId(
  draftId: string,
  draftProjectId: string | null | undefined
): string | null | undefined {
  return draftProjectId === undefined
    ? getProjectIdFromDraftId(draftId)
    : draftProjectId;
}

export function isNewChatDraftId(draftId: string): boolean {
  return (
    draftId.startsWith(TAB_DRAFT_ID_PREFIX) ||
    draftId.startsWith(PROJECT_DRAFT_ID_PREFIX)
  );
}
